import { interviewType } from '../../enums';

export default () => ({
  namespaced: true,

  state: {
    activeInterviewType: interviewType.OFFICE_INTERVIEW,
    activeTab: 0,
    activeQuestion: 0,
    officeInterviewPlayerTime: 0,
  },

  mutations: {
    reset(state) {
      state.activeTab = 0;
      state.activeQuestion = 0;
      state.activeInterviewType = interviewType.OFFICE_INTERVIEW;
      state.officeInterviewPlayerTime = 0;
    },
    setActiveInterviewType(state, type) {
      state.activeInterviewType = type;
    },
    setActiveQuestion(state, question) {
      state.activeQuestion = question;
    },
    setActiveTab(state, tab) {
      state.activeTab = tab;
    },
    setOfficeInterviewPlayerTime(state, value) {
      state.officeInterviewPlayerTime = value;
    },
  },

  getters: {
    activeTab(state) {
      return state.activeTab;
    },
    activeInterviewType(state) {
      return state.activeInterviewType;
    },
    activeQuestion(state) {
      return state.activeQuestion;
    },
    officeInterviewPlayerTime(state) {
      return state.officeInterviewPlayerTime;
    },
  },
});
